import { render, staticRenderFns } from "./CompanyProps.vue?vue&type=template&id=6202bdec&"
import script from "./CompanyProps.vue?vue&type=script&lang=js&"
export * from "./CompanyProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports